module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAMAAACelLz8AAAAYFBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////98JRy6AAAAH3RSTlMAveSUJtljSbF2Mw0M8x2SEfoW8u3GqqFA3IiGfG5S2VYeDwAAAMtJREFUKM+FktkSgyAMRZMQROu+dW/5/7+s0OBoqXpeYOZA5k4SCHCGuiw1ZgxrTkjKcFGwUYSnpVGUwExCCgINpjksyFNs5Io1/FCjVEshIlU+AeWxysllwSlB9SY707+6KQsCME3aquoSzLl6tgBADJlyypK5aidu/nQJMkDjlH99b9uH++2VQdAsyg5J1yWDFcUaykLUBI7WBlWUopaI6qVgrFhLjFgZlPBrJDzTf0X8bZRem9E1aqe920PZHuXxAsRrc7RsOyv6ATRTGK4c7th5AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/comm/images/document-conversion/mail.png
// module id = 41iB
// module chunks = 2